import { ListeTable } from '@mairistem/liste';

type ArretePeriodiqueListeTableHeaderProps = {
  [key: string]: any;
};

const ArretePeriodiqueListeTableHeader = (props: ArretePeriodiqueListeTableHeaderProps) => {
  const { ...rest } = props;

  return (
    <>
      <ListeTable.Column {...rest} name="libelle" verticalAlign="middle">
        Libellé
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="date" style={{ width: 140 }} verticalAlign="middle">
        Date d&apos;arrêté
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="regisseur" style={{ width: 200 }} verticalAlign="middle">
        Régisseur
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montantTotal"
        style={{ width: 150 }}
        verticalAlign="middle"
      >
        Montant
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="titrage" style={{ width: 130 }} verticalAlign="middle">
        Titrage
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="document" style={{ width: 160 }} verticalAlign="middle">
        Document
      </ListeTable.Column>
    </>
  );
};

export default ArretePeriodiqueListeTableHeader;
